// Page-level translations for Services, About, Support and Coverage. Merged into t() alongside translations.js
export const pageTranslations = {
  en: {
    "srv.eyebrow": "Our Services",
    "srv.title": "Everything your parcel needs",
    "srv.subtitle": "We specialise in door-to-door delivery across Europe — and we send parcels to every other country in the world too. Every step is handled with precision and care.",
    "abt.eyebrow": "About Us",
    "abt.title": "Bringing homes closer, {one parcel at a time}",
    "abt.p1": "SmartLogistics is a door-to-door delivery service built for people living away from home. We pick up parcels from any doorstep across Europe — including Italy — and deliver them safely to loved ones in Sri Lanka, India, Bangladesh and the Philippines, as well as across Europe and to the UK.",
    "abt.p2": "No queues. No depots. No stress. Just a courier at your door and a smile at the other end. Everything is coordinated through our team and our WhatsApp line, so help is always a message away.",
    "sup.eyebrow": "Customer Support",
    "sup.title": "We're here to help, 24/7",
    "sup.subtitle": "Reach us on WhatsApp, phone or email. Find quick answers below or leave us a review.",
    "cov.eyebrow": "Coverage & Warehouses",
    "cov.title": "We ship to every country in the world",
    "cov.subtitle": "Send a parcel from any country to any country — door to door. Search below to find yours, then start your shipment.",
    "cov.warehouses": "Our warehouses",
    "cov.warehousesSub": "Strategically located hubs that keep your parcels moving fast around the globe.",
    "cov.countries": "Countries we serve",
    "cov.countriesSub": "Pick-up and delivery available worldwide. Tap a country to start a shipment.",
    "cov.available": "Available",
    "cov.match": "match",
    "cov.searchPlaceholder": "Search any country…",
    "cov.notFound": "We couldn't find that country — message us and we'll sort it out!",
    "cov.ask": "Ask us on WhatsApp",
  },
  si: {
    "srv.eyebrow": "අපගේ සේවාවන්",
    "srv.title": "ඔබේ පාර්සලයට අවශ්‍ය සියල්ල",
    "srv.subtitle": "අපි යුරෝපය පුරා දොරින් දොරට බෙදාහැරීමේ විශේෂඥයන් වන අතර ලෝකයේ අනෙකුත් සෑම රටකටම පාර්සල් යවමු. සෑම පියවරක්ම නිරවද්‍යතාවයෙන් සහ සැලකිල්ලෙන් හසුරුවනු ලැබේ.",
    "abt.eyebrow": "අප ගැන",
    "abt.title": "නිවෙස් සමීප කරමින්, {එක් පාර්සලයක් බැගින්}",
    "abt.p1": "SmartLogistics යනු නිවසින් ඈත ජීවත් වන අය සඳහා නිර්මාණය කළ දොරින් දොරට බෙදාහැරීමේ සේවාවකි. අපි යුරෝපය පුරා (ඉතාලිය ඇතුළුව) ඕනෑම දොරකඩකින් පාර්සල් රැගෙන ශ්‍රී ලංකාව, ඉන්දියාව, බංග්ලාදේශය සහ පිලිපීනයේ ඔබේ ආදරණීයයන්ට මෙන්ම යුරෝපය පුරා සහ එක්සත් රාජධානියටද ආරක්ෂිතව බෙදාහරිමු.",
    "abt.p2": "පෝලිම් නැත. ගබඩා නැත. ආතතියක් නැත. ඔබේ දොරකඩ කුරියර් කෙනෙක් සහ අනෙක් පැත්තේ සිනාවක් පමණි. සියල්ල අපගේ කණ්ඩායම සහ WhatsApp හරහා සම්බන්ධීකරණය වේ.",
    "sup.eyebrow": "පාරිභෝගික සහාය",
    "sup.title": "අපි උදව් කිරීමට සූදානම්, පැය 24/7",
    "sup.subtitle": "WhatsApp, දුරකථනය හෝ විද්‍යුත් තැපෑලෙන් අප හා සම්බන්ධ වන්න. පහතින් ඉක්මන් පිළිතුරු සොයාගන්න හෝ සමාලෝචනයක් තබන්න.",
    "cov.eyebrow": "ආවරණය සහ ගබඩා",
    "cov.title": "අපි ලෝකයේ සෑම රටකටම යවමු",
    "cov.subtitle": "ඕනෑම රටකින් ඕනෑම රටකට දොරින් දොරට පාර්සලයක් යවන්න. පහතින් ඔබේ රට සොයාගෙන ඔබේ ගමන ආරම්භ කරන්න.",
    "cov.warehouses": "අපගේ ගබඩා",
    "cov.warehousesSub": "ඔබේ පාර්සල් ලොව පුරා වේගයෙන් ගෙනයන උපායමාර්ගික මධ්‍යස්ථාන.",
    "cov.countries": "අප සේවය කරන රටවල්",
    "cov.countriesSub": "එකතු කිරීම සහ බෙදාහැරීම ලොව පුරා ලබාගත හැක. ගමනක් ආරම්භ කිරීමට රටක් තට්ටු කරන්න.",
    "cov.available": "ලබාගත හැක",
    "cov.match": "ගැළපීම්",
    "cov.searchPlaceholder": "ඕනෑම රටක් සොයන්න…",
    "cov.notFound": "එම රට සොයාගත නොහැකි විය — අපට පණිවිඩයක් දෙන්න, අපි එය විසඳමු!",
    "cov.ask": "WhatsApp හරහා අසන්න",
  },
  ta: {
    "srv.eyebrow": "எங்கள் சேவைகள்",
    "srv.title": "உங்கள் பார்சலுக்குத் தேவையான அனைத்தும்",
    "srv.subtitle": "நாங்கள் ஐரோப்பா முழுவதும் வாசல் முதல் வாசல் வரை வழங்குவதில் நிபுணத்துவம் பெற்றவர்கள் — உலகின் மற்ற எல்லா நாடுகளுக்கும் பார்சல்களை அனுப்புகிறோம். ஒவ்வொரு படியும் துல்லியமாகவும் கவனமாகவும் கையாளப்படுகிறது.",
    "abt.eyebrow": "எங்களைப் பற்றி",
    "abt.title": "வீடுகளை நெருக்கமாக்குகிறோம், {ஒரு பார்சல் ஒரு முறை}",
    "abt.p1": "SmartLogistics வீட்டை விட்டு தொலைவில் வாழ்பவர்களுக்காக உருவாக்கப்பட்ட வாசல் முதல் வாசல் வழங்கல் சேவையாகும். ஐரோப்பா முழுவதும் (இத்தாலி உட்பட) எந்த வாசலிலிருந்தும் பார்சல்களை எடுத்து இலங்கை, இந்தியா, பங்களாதேஷ் மற்றும் பிலிப்பைன்ஸ் உள்ள உங்கள் அன்பானவர்களுக்கும், ஐரோப்பா முழுவதும் மற்றும் இங்கிலாந்துக்கும் பாதுகாப்பாக வழங்குகிறோம்.",
    "abt.p2": "வரிசை இல்லை. கிடங்கு இல்லை. மன அழுத்தம் இல்லை. உங்கள் வாசலில் ஒரு கூரியர் மற்றும் மறுமுனையில் ஒரு புன்னகை மட்டுமே. அனைத்தும் எங்கள் குழு மற்றும் WhatsApp வழியாக ஒருங்கிணைக்கப்படுகிறது.",
    "sup.eyebrow": "வாடிக்கையாளர் ஆதரவு",
    "sup.title": "நாங்கள் உதவ தயார், 24/7",
    "sup.subtitle": "WhatsApp, தொலைபேசி அல்லது மின்னஞ்சல் மூலம் எங்களை அணுகவும். கீழே விரைவான பதில்களைக் கண்டறியவும் அல்லது ஒரு மதிப்பாய்வை விடவும்.",
    "cov.eyebrow": "பரப்பளவு & கிடங்குகள்",
    "cov.title": "உலகின் எல்லா நாடுகளுக்கும் அனுப்புகிறோம்",
    "cov.subtitle": "எந்த நாட்டிலிருந்தும் எந்த நாட்டிற்கும் வாசல் முதல் வாசல் வரை பார்சல் அனுப்புங்கள். கீழே உங்களுடையதைக் கண்டுபிடித்து உங்கள் அனுப்பீட்டைத் தொடங்குங்கள்.",
    "cov.warehouses": "எங்கள் கிடங்குகள்",
    "cov.warehousesSub": "உங்கள் பார்சல்களை உலகம் முழுவதும் வேகமாக நகர்த்தும் மூலோபாய மையங்கள்.",
    "cov.countries": "நாங்கள் சேவை செய்யும் நாடுகள்",
    "cov.countriesSub": "சேகரிப்பு மற்றும் வழங்கல் உலகம் முழுவதும் கிடைக்கிறது. அனுப்பீட்டைத் தொடங்க ஒரு நாட்டைத் தட்டவும்.",
    "cov.available": "கிடைக்கிறது",
    "cov.match": "பொருத்தம்",
    "cov.searchPlaceholder": "எந்த நாட்டையும் தேடுங்கள்…",
    "cov.notFound": "அந்த நாட்டைக் கண்டுபிடிக்க முடியவில்லை — எங்களுக்கு செய்தி அனுப்புங்கள், நாங்கள் சரிசெய்கிறோம்!",
    "cov.ask": "WhatsApp இல் கேளுங்கள்",
  },
  it: {
    "srv.eyebrow": "I nostri servizi",
    "srv.title": "Tutto ciò di cui il tuo pacco ha bisogno",
    "srv.subtitle": "Siamo specializzati nella consegna porta a porta in tutta Europa — e spediamo pacchi anche in ogni altro paese del mondo. Ogni passaggio è gestito con precisione e cura.",
    "abt.eyebrow": "Chi siamo",
    "abt.title": "Avviciniamo le case, {un pacco alla volta}",
    "abt.p1": "SmartLogistics è un servizio di consegna porta a porta creato per chi vive lontano da casa. Ritiriamo pacchi da qualsiasi porta in Europa — Italia inclusa — e li consegniamo in sicurezza ai tuoi cari in Sri Lanka, India, Bangladesh e Filippine, oltre che in tutta Europa e nel Regno Unito.",
    "abt.p2": "Niente code. Niente depositi. Niente stress. Solo un corriere alla tua porta e un sorriso dall'altra parte. Tutto è coordinato dal nostro team e dalla nostra linea WhatsApp.",
    "sup.eyebrow": "Assistenza clienti",
    "sup.title": "Siamo qui per aiutarti, 24/7",
    "sup.subtitle": "Contattaci su WhatsApp, telefono o email. Trova risposte rapide qui sotto o lasciaci una recensione.",
    "cov.eyebrow": "Copertura e magazzini",
    "cov.title": "Spediamo in ogni paese del mondo",
    "cov.subtitle": "Invia un pacco da qualsiasi paese a qualsiasi paese — porta a porta. Cerca qui sotto il tuo e avvia la spedizione.",
    "cov.warehouses": "I nostri magazzini",
    "cov.warehousesSub": "Hub in posizioni strategiche che tengono i tuoi pacchi in movimento veloce nel mondo.",
    "cov.countries": "Paesi che serviamo",
    "cov.countriesSub": "Ritiro e consegna disponibili in tutto il mondo. Tocca un paese per avviare una spedizione.",
    "cov.available": "Disponibile",
    "cov.match": "risultati",
    "cov.searchPlaceholder": "Cerca un paese qualsiasi…",
    "cov.notFound": "Non abbiamo trovato quel paese — scrivici e lo risolveremo!",
    "cov.ask": "Chiedici su WhatsApp",
  },
  fil: {
    "srv.eyebrow": "Aming mga Serbisyo",
    "srv.title": "Lahat ng kailangan ng iyong pakete",
    "srv.subtitle": "Dalubhasa kami sa paghahatid pinto sa pinto sa buong Europa — at nagpapadala rin kami ng pakete sa bawat ibang bansa sa mundo. Bawat hakbang ay pinangangasiwaan nang may pag-iingat.",
    "abt.eyebrow": "Tungkol sa Amin",
    "abt.title": "Pinaglalapit ang mga tahanan, {isang pakete sa bawat pagkakataon}",
    "abt.p1": "Ang SmartLogistics ay isang serbisyong paghahatid pinto sa pinto para sa mga naninirahan malayo sa tahanan. Kinukuha namin ang mga pakete mula sa anumang pintuan sa Europa — kasama ang Italya — at inihahatid nang ligtas sa iyong mga mahal sa buhay sa Sri Lanka, India, Bangladesh at Pilipinas, gayundin sa buong Europa at UK.",
    "abt.p2": "Walang pila. Walang depot. Walang stress. Isang courier lang sa iyong pinto at ngiti sa kabilang dulo. Lahat ay pinag-uugnay sa pamamagitan ng aming team at WhatsApp.",
    "sup.eyebrow": "Suporta sa Customer",
    "sup.title": "Narito kami para tumulong, 24/7",
    "sup.subtitle": "Kontakin kami sa WhatsApp, telepono o email. Maghanap ng mabilis na sagot sa ibaba o mag-iwan ng review.",
    "cov.eyebrow": "Saklaw at mga Bodega",
    "cov.title": "Nagpapadala kami sa bawat bansa sa mundo",
    "cov.subtitle": "Magpadala ng pakete mula sa anumang bansa papunta sa anumang bansa — pinto sa pinto. Hanapin ang iyo sa ibaba at simulan ang iyong padala.",
    "cov.warehouses": "Aming mga bodega",
    "cov.warehousesSub": "Mga estratehikong hub na nagpapabilis ng galaw ng iyong pakete sa buong mundo.",
    "cov.countries": "Mga bansang sineserbisyuhan namin",
    "cov.countriesSub": "May pagkuha at paghahatid sa buong mundo. Pindutin ang bansa upang magsimula ng padala.",
    "cov.available": "Available",
    "cov.match": "tugma",
    "cov.searchPlaceholder": "Maghanap ng anumang bansa…",
    "cov.notFound": "Hindi namin nahanap ang bansang iyon — mag-message sa amin at aayusin namin!",
    "cov.ask": "Magtanong sa WhatsApp",
  },
  th: {
    "srv.eyebrow": "บริการของเรา",
    "srv.title": "ทุกสิ่งที่พัสดุของคุณต้องการ",
    "srv.subtitle": "เราเชี่ยวชาญการจัดส่งถึงหน้าประตูทั่วยุโรป — และเราส่งพัสดุไปยังทุกประเทศทั่วโลกด้วย ทุกขั้นตอนดำเนินการอย่างแม่นยำและใส่ใจ",
    "abt.eyebrow": "เกี่ยวกับเรา",
    "abt.title": "ทำให้บ้านใกล้กันมากขึ้น {ทีละพัสดุ}",
    "abt.p1": "SmartLogistics เป็นบริการจัดส่งถึงหน้าประตูที่สร้างขึ้นสำหรับผู้ที่อยู่ห่างบ้าน เรารับพัสดุจากหน้าประตูใดก็ได้ทั่วยุโรป — รวมถึงอิตาลี — และจัดส่งอย่างปลอดภัยถึงคนที่คุณรักในศรีลังกา อินเดีย บังกลาเทศ และฟิลิปปินส์ รวมถึงทั่วยุโรปและสหราชอาณาจักร",
    "abt.p2": "ไม่ต้องต่อคิว ไม่มีคลังสินค้า ไม่มีความเครียด เพียงพนักงานส่งที่หน้าประตูของคุณและรอยยิ้มที่ปลายทาง ทุกอย่างประสานงานผ่านทีมงานและ WhatsApp ของเรา",
    "sup.eyebrow": "ฝ่ายบริการลูกค้า",
    "sup.title": "เราพร้อมช่วยเหลือ ตลอด 24 ชั่วโมง",
    "sup.subtitle": "ติดต่อเราทาง WhatsApp โทรศัพท์ หรืออีเมล ค้นหาคำตอบด่วนด้านล่างหรือเขียนรีวิวให้เรา",
    "cov.eyebrow": "พื้นที่ให้บริการและคลังสินค้า",
    "cov.title": "เราจัดส่งไปยังทุกประเทศทั่วโลก",
    "cov.subtitle": "ส่งพัสดุจากประเทศใดก็ได้ไปยังประเทศใดก็ได้ — ถึงหน้าประตู ค้นหาประเทศของคุณด้านล่างแล้วเริ่มการจัดส่ง",
    "cov.warehouses": "คลังสินค้าของเรา",
    "cov.warehousesSub": "ศูนย์กระจายสินค้าที่ตั้งอยู่ในทำเลยุทธศาสตร์เพื่อให้พัสดุของคุณเคลื่อนที่อย่างรวดเร็วทั่วโลก",
    "cov.countries": "ประเทศที่เราให้บริการ",
    "cov.countriesSub": "มีบริการรับและส่งทั่วโลก แตะที่ประเทศเพื่อเริ่มการจัดส่ง",
    "cov.available": "พร้อมให้บริการ",
    "cov.match": "ผลลัพธ์",
    "cov.searchPlaceholder": "ค้นหาประเทศใดก็ได้…",
    "cov.notFound": "เราไม่พบประเทศนั้น — ส่งข้อความหาเราแล้วเราจะจัดการให้!",
    "cov.ask": "สอบถามทาง WhatsApp",
  },
  ro: {
    "srv.eyebrow": "Serviciile noastre",
    "srv.title": "Tot ce are nevoie coletul tău",
    "srv.subtitle": "Suntem specializați în livrarea din ușă în ușă în toată Europa — și trimitem colete în orice altă țară din lume. Fiecare pas este gestionat cu precizie și grijă.",
    "abt.eyebrow": "Despre noi",
    "abt.title": "Apropiem casele, {un colet pe rând}",
    "abt.p1": "SmartLogistics este un serviciu de livrare din ușă în ușă creat pentru cei care trăiesc departe de casă. Ridicăm colete de la orice ușă din Europa — inclusiv Italia — și le livrăm în siguranță celor dragi din Sri Lanka, India, Bangladesh și Filipine, precum și în toată Europa și în Regatul Unit.",
    "abt.p2": "Fără cozi. Fără depozite. Fără stres. Doar un curier la ușa ta și un zâmbet la celălalt capăt. Totul este coordonat prin echipa noastră și linia WhatsApp.",
    "sup.eyebrow": "Asistență clienți",
    "sup.title": "Suntem aici să ajutăm, 24/7",
    "sup.subtitle": "Contactează-ne pe WhatsApp, telefon sau email. Găsește răspunsuri rapide mai jos sau lasă-ne o recenzie.",
    "cov.eyebrow": "Acoperire și depozite",
    "cov.title": "Livrăm în orice țară din lume",
    "cov.subtitle": "Trimite un colet din orice țară către orice țară — din ușă în ușă. Caută mai jos țara ta și începe expedierea.",
    "cov.warehouses": "Depozitele noastre",
    "cov.warehousesSub": "Huburi amplasate strategic care mențin coletele tale în mișcare rapidă în întreaga lume.",
    "cov.countries": "Țările pe care le deservim",
    "cov.countriesSub": "Ridicare și livrare disponibile în toată lumea. Atinge o țară pentru a începe o expediere.",
    "cov.available": "Disponibil",
    "cov.match": "rezultate",
    "cov.searchPlaceholder": "Caută orice țară…",
    "cov.notFound": "Nu am găsit acea țară — scrie-ne și rezolvăm!",
    "cov.ask": "Întreabă-ne pe WhatsApp",
  },
  bn: {
    "srv.eyebrow": "আমাদের সেবা",
    "srv.title": "আপনার পার্সেলের জন্য যা কিছু প্রয়োজন",
    "srv.subtitle": "আমরা সমগ্র ইউরোপ জুড়ে দ্বারে দ্বারে ডেলিভারিতে বিশেষজ্ঞ — এবং বিশ্বের অন্য সব দেশেও পার্সেল পাঠাই। প্রতিটি ধাপ নির্ভুলতা ও যত্নসহকারে পরিচালিত হয়।",
    "abt.eyebrow": "আমাদের সম্পর্কে",
    "abt.title": "বাড়িগুলোকে কাছে আনছি, {একটি করে পার্সেলে}",
    "abt.p1": "SmartLogistics হলো ঘর থেকে দূরে বসবাসকারীদের জন্য তৈরি একটি দ্বারে দ্বারে ডেলিভারি সেবা। আমরা ইউরোপ জুড়ে (ইতালি সহ) যেকোনো দরজা থেকে পার্সেল সংগ্রহ করে শ্রীলঙ্কা, ভারত, বাংলাদেশ ও ফিলিপাইনের প্রিয়জনদের কাছে, পাশাপাশি সমগ্র ইউরোপ ও যুক্তরাজ্যে নিরাপদে পৌঁছে দিই।",
    "abt.p2": "কোনো লাইন নেই। কোনো ডিপো নেই। কোনো চাপ নেই। শুধু আপনার দরজায় একজন কুরিয়ার এবং অন্য প্রান্তে একটি হাসি। সবকিছু আমাদের দল ও WhatsApp-এর মাধ্যমে সমন্বিত হয়।",
    "sup.eyebrow": "গ্রাহক সহায়তা",
    "sup.title": "আমরা সাহায্য করতে প্রস্তুত, 24/7",
    "sup.subtitle": "WhatsApp, ফোন বা ইমেইলে আমাদের সাথে যোগাযোগ করুন। নিচে দ্রুত উত্তর খুঁজুন অথবা একটি রিভিউ দিন।",
    "cov.eyebrow": "কভারেজ ও গুদাম",
    "cov.title": "আমরা বিশ্বের প্রতিটি দেশে পাঠাই",
    "cov.subtitle": "যেকোনো দেশ থেকে যেকোনো দেশে দ্বারে দ্বারে পার্সেল পাঠান। নিচে আপনার দেশ খুঁজে আপনার চালান শুরু করুন।",
    "cov.warehouses": "আমাদের গুদাম",
    "cov.warehousesSub": "কৌশলগতভাবে অবস্থিত হাব যা আপনার পার্সেলকে বিশ্বজুড়ে দ্রুত চলমান রাখে।",
    "cov.countries": "আমরা যে দেশগুলোতে সেবা দিই",
    "cov.countriesSub": "সংগ্রহ ও ডেলিভারি বিশ্বজুড়ে উপলব্ধ। চালান শুরু করতে একটি দেশে ট্যাপ করুন।",
    "cov.available": "উপলব্ধ",
    "cov.match": "মিল",
    "cov.searchPlaceholder": "যেকোনো দেশ খুঁজুন…",
    "cov.notFound": "সেই দেশ খুঁজে পাওয়া যায়নি — আমাদের বার্তা দিন, আমরা ঠিক করে দেব!",
    "cov.ask": "WhatsApp-এ জিজ্ঞাসা করুন",
  },
  vi: {
    "srv.eyebrow": "Dịch vụ của chúng tôi",
    "srv.title": "Mọi thứ bưu kiện của bạn cần",
    "srv.subtitle": "Chúng tôi chuyên giao hàng tận nhà khắp châu Âu — và cũng gửi bưu kiện đến mọi quốc gia khác trên thế giới. Mỗi bước đều được xử lý chính xác và cẩn thận.",
    "abt.eyebrow": "Về chúng tôi",
    "abt.title": "Đưa những ngôi nhà lại gần nhau, {từng bưu kiện một}",
    "abt.p1": "SmartLogistics là dịch vụ giao hàng tận nhà dành cho những người sống xa nhà. Chúng tôi lấy bưu kiện từ bất kỳ cửa nhà nào ở châu Âu — bao gồm Ý — và giao an toàn đến người thân của bạn ở Sri Lanka, Ấn Độ, Bangladesh và Philippines, cũng như khắp châu Âu và Vương quốc Anh.",
    "abt.p2": "Không xếp hàng. Không kho bãi. Không căng thẳng. Chỉ có nhân viên giao hàng tại cửa nhà bạn và một nụ cười ở đầu bên kia. Mọi thứ được điều phối qua đội ngũ và đường dây WhatsApp của chúng tôi.",
    "sup.eyebrow": "Hỗ trợ khách hàng",
    "sup.title": "Chúng tôi luôn sẵn sàng hỗ trợ, 24/7",
    "sup.subtitle": "Liên hệ với chúng tôi qua WhatsApp, điện thoại hoặc email. Tìm câu trả lời nhanh bên dưới hoặc để lại đánh giá.",
    "cov.eyebrow": "Phạm vi & Kho hàng",
    "cov.title": "Chúng tôi giao đến mọi quốc gia trên thế giới",
    "cov.subtitle": "Gửi bưu kiện từ bất kỳ quốc gia nào đến bất kỳ quốc gia nào — tận nhà. Tìm quốc gia của bạn bên dưới rồi bắt đầu gửi hàng.",
    "cov.warehouses": "Kho hàng của chúng tôi",
    "cov.warehousesSub": "Các trung tâm được đặt ở vị trí chiến lược giúp bưu kiện của bạn di chuyển nhanh khắp thế giới.",
    "cov.countries": "Các quốc gia chúng tôi phục vụ",
    "cov.countriesSub": "Có dịch vụ lấy và giao hàng trên toàn thế giới. Nhấn vào một quốc gia để bắt đầu gửi hàng.",
    "cov.available": "Có sẵn",
    "cov.match": "kết quả",
    "cov.searchPlaceholder": "Tìm bất kỳ quốc gia nào…",
    "cov.notFound": "Chúng tôi không tìm thấy quốc gia đó — nhắn cho chúng tôi và chúng tôi sẽ xử lý!",
    "cov.ask": "Hỏi chúng tôi trên WhatsApp",
  },
};
